/**
 * Table used in UsageTab to display the service usage.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */
import {
  IampHeaderIconTitle,
  IampTableColumnHeader,
} from '@/components/IampTable'
import '@/components/IampTable.css'
import { TaskDetail } from '@/pages/Billing/Invoice'
import { BiChip } from 'react-icons/bi'
import { PiMusicNotes } from 'react-icons/pi'
import './UsageTaskTable.css'

/**
 * The list of column headers of the task table.
 */
export const UsageTaskTableHeaderList: IampTableColumnHeader[] = [
  {
    icon: <BiChip />,
    title: 'Product',
  },
  {
    className: 'track-processed-column',
    icon: <PiMusicNotes />,
    title: 'Tracks processed',
  },
]

interface UsageTaskTableProps {
  taskDetailList: Record<string, TaskDetail>
}

/**
 * The table showing the usage data of the selected month, per product.
 */
export const UsageTaskTable = (props: UsageTaskTableProps) => {
  return (
    <table className="iamp-table usage-table">
      <thead>
        <tr>
          {UsageTaskTableHeaderList.map((header: IampTableColumnHeader) => (
            <IampHeaderIconTitle key={header.title} {...header} />
          ))}
        </tr>
      </thead>

      <tbody>
        {Object.values(props.taskDetailList)
          .sort((a, b) => a.moduleName.localeCompare(b.moduleName))
          .map((detail, index) => (
            <tr key={index}>
              <td>{detail.moduleName}</td>
              <td className="track-processed-column">
                {detail.trackProcessedCount}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  )
}
